import api from '../../Services/api';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { createInvoicePages, createTable } from "../../Services/InvoiceService";
import TransferInvoiceHeader from "./TransferInvoiceHeader";
import TransferAutographFooter from "./TransferAutographFooter";

function TransferDetailRow({ transferDetail }) {
  return <>
    <tr key={`invrow-${transferDetail.id}`}>
      <td className='checkbox-col'>
        <div className='invoice-checkbox'></div>
      </td>
      <td className='text-center'>{transferDetail.quantity}</td>
      <td className='name-col'>
        <div className="name-text">{transferDetail.product.name}</div>
      </td>
    </tr>
  </>
}

function TransferTableHeader({ pageIndex }) {
  return <>
    <thead>
      <tr>
        <th className='checkbox-col'>{pageIndex}</th>
        <th className="text-center px-2">Qty</th>
        <th className='name-col'>
          <div className="name-text px-2">Nama Barang</div>
        </th>
      </tr>
    </thead>
  </>
}

const InvoiceTransfer = () => {
  const { uuid } = useParams();
  const [transferData, setTransferData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true)
    api.get(`/data/stock-transfer/?uuid=${uuid}`)
      .then(res => {
        setTransferData(res.data)
        setIsLoading(false)
      })
  }, [uuid])

  if (isLoading) {
    return (
      <Spinner className="spinner" animation="border" role="status" size="xl">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  }

  const invoiceHeader = <TransferInvoiceHeader transferData={transferData} />
  const pages = createInvoicePages(
    transferData.stocktransferformdetail_set,
    invoiceHeader,
    (pageIndex, page, isLastPage) => {
      const thead = <TransferTableHeader pageIndex={pageIndex + 1} />
      const tableRows = []
      for (let transferDetail of page) {
        tableRows.push(<TransferDetailRow transferDetail={transferDetail} />)
      }
      return createTable(thead, tableRows)
    },
    <TransferAutographFooter />
  )

  return <>
    <div className="container px-0 invoice-actions-container d-print-none" style={{ 'maxWidth': '850px' }}>
      <button className='btn action-button mx-2 d-print-none' onClick={window.print}>Print</button>
    </div>

    {Object.keys(pages).map((pageNumber, index) => {
      return pages[pageNumber]
    })}
  </>
}

export default InvoiceTransfer
